<template>
  <TvBase storage-key="tv4id">
    <div v-if="state === 'INTERSTICIEL'" class="view tv dark">
      <IntersticeFour />
    </div>
    <div v-if="state !== 'INTERSTICIEL' && screenData" class="view tv dark">
      <Screen v-if="state === ''" :data="screen4">
        <TransportDetail class="transport-detail" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && distribution === 'LOCALISATION'" :data="transitLocalisation">
        <BarChart :commuters="transitLocalisation.data.entries" :colors="transitLocalisation.data.colors" />
      </Screen>
      <Screen v-if="state === 'TRANSIT' && (distribution === 'TIME' || distribution === 'PERCENTAGE')" :data="screen1">
        <BarPlotChart
          :chart-width="1920"
          :chart-height="850"
          :chart-margin="{ top: 32, right: 128, bottom: 64, left: 64 }"
          :data="screen1.data.entries"
          :advencedMode="graphAdvencedMode"
          :index="index"
        />
      </Screen>
      <Screen v-if="state === 'IMPACT'" :data="impactTv4">
        <Proportion class="dark tv" :data="screenData" :index="index" />
      </Screen>
      <Screen v-if="state === 'OUTLIER' && index >= 0" :data="outlierTv4">
        <OutlierDetail :index="Math.max(index, 0)" :screenData="screenData" />
      </Screen>
      <Screen v-if="state === 'OUTLIER' && index < 0" :data="outlierTv4">
        <div class="title">Focus par site cible</div>
      </Screen>
      <Screen v-if="state === 'ENVIRONMENTAL'" :data="environmentalTv4">
        <EnvironmentalGraph :index="index" :screenData="screenData" />
      </Screen>
    </div>
  </TvBase>
</template>

<script>
import Tv from './TvMixin';
import OutlierDetail from '@/components/Screen/OutlierDetail';
import TransportDetail from '@/components/Map/Analysis/Detail/TransportDetail';
import Proportion from '@/components/Analysis/Impact/Proportion';
import EnvironmentalGraph from '@/components/Screen/EnvironmentalGraph';

export default {
  name: 'Tv4',

  components: {
    OutlierDetail,
    TransportDetail,
    Proportion,
    EnvironmentalGraph,
  },

  mixins: [Tv],

  data() {
    return {
      state: 'INTERSTICIEL',
      lastState: '',
      distribution: 'LOCALISATION',
      graphAdvencedMode: false,
      index: -1,
      screenData: null,
    };
  },

  computed: {
    transitLocalisation() {
      const { collaboratorsByRegion, filteredCollaboratorsCount } = this.screenData;
      const entries = collaboratorsByRegion
        .sort((a, b) => {
          return b.count - a.count;
        })
        .slice(0, 8)
        .map(item => {
          const { caption, count, country } = item;
          return [
            `${caption || this.$t('notProvided')}|${country || this.$t('notProvided')}`,
            filteredCollaboratorsCount ? count / filteredCollaboratorsCount : 0,
          ];
        });
      return {
        heading: {
          caption: this.$t('collaboratorLocation'),
          icon: 'people',
        },
        data: {
          entries,
          colors: ['#D60808', '#D8D8D8', '#f1e7ca', '#8b8181', '#9a054a', '#602376', '#7874b5', '#ed700a'],
        },
      };
    },

    screen4() {
      return {};
    },

    screen1() {
      let values = this.screenData.sites.map(e => {
        return {
          site: e.name,
          r010: e.details.collaboratorsByTimeRanges[0].count,
          r1120: e.details.collaboratorsByTimeRanges[1].count,
          r2130: e.details.collaboratorsByTimeRanges[2].count,
          r3140: e.details.collaboratorsByTimeRanges[3].count,
          r4150: e.details.collaboratorsByTimeRanges[4].count,
          r5160: e.details.collaboratorsByTimeRanges[5].count,

          r030: e.details.collaboratorsByTimeRanges[0].count + e.details.collaboratorsByTimeRanges[1].count + e.details.collaboratorsByTimeRanges[2].count,
          r3160: e.details.collaboratorsByTimeRanges[3].count + e.details.collaboratorsByTimeRanges[4].count + e.details.collaboratorsByTimeRanges[5].count,
          r60: e.details.collaboratorsByTimeRanges[6].count,

          t45:
            e.details.collaboratorsByTimeRanges[0].count +
            e.details.collaboratorsByTimeRanges[1].count +
            e.details.collaboratorsByTimeRanges[2].count +
            e.details.collaboratorsByTimeRanges[3].count +
            (e.details.collaboratorsByTimeRanges[4].count * (e.details.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,
          total:
            e.details.collaboratorsByTimeRanges[0].count +
            e.details.collaboratorsByTimeRanges[1].count +
            e.details.collaboratorsByTimeRanges[2].count +
            e.details.collaboratorsByTimeRanges[3].count +
            e.details.collaboratorsByTimeRanges[4].count +
            e.details.collaboratorsByTimeRanges[5].count +
            e.details.collaboratorsByTimeRanges[6].count,
        };
      });

      values.unshift({
        site: this.$t('actualSites', this.screenData.actualSites.length),
        r010: this.screenData.collaboratorsByTimeRanges[0].count,
        r1120: this.screenData.collaboratorsByTimeRanges[1].count,
        r2130: this.screenData.collaboratorsByTimeRanges[2].count,
        r3140: this.screenData.collaboratorsByTimeRanges[3].count,
        r4150: this.screenData.collaboratorsByTimeRanges[4].count,
        r5160: this.screenData.collaboratorsByTimeRanges[5].count,

        r030:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count,
        r3160:
          this.screenData.collaboratorsByTimeRanges[3].count +
          this.screenData.collaboratorsByTimeRanges[4].count +
          this.screenData.collaboratorsByTimeRanges[5].count,
        r60: this.screenData.collaboratorsByTimeRanges[6].count,

        t45:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count +
          this.screenData.collaboratorsByTimeRanges[3].count +
          (this.screenData.collaboratorsByTimeRanges[4].count * (this.screenData.collaboratorsByTimeRanges[4].averageTime - 40)) / 10,
        total:
          this.screenData.collaboratorsByTimeRanges[0].count +
          this.screenData.collaboratorsByTimeRanges[1].count +
          this.screenData.collaboratorsByTimeRanges[2].count +
          this.screenData.collaboratorsByTimeRanges[3].count +
          this.screenData.collaboratorsByTimeRanges[4].count +
          this.screenData.collaboratorsByTimeRanges[5].count +
          this.screenData.collaboratorsByTimeRanges[6].count,
      });

      return {
        heading: {
          caption: this.$t('collaboratorsByAccessTime'),
          icon: 'clock',
        },
        data: {
          entries: values,
          advencedMode: true,
        },
      };
    },

    impactTv4() {
      return {
        heading: {
          caption: this.$t('sections.impact'),
          icon: 'happy',
        },
      };
    },

    outlierTv4() {
      return null;
    },

    environmentalTv4() {
      return {
        heading: {
          caption: this.$t('sections.environmental'),
          icon: 'environment',
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 400px auto;
  font-family: 'Golden Plains';
  font-size: 128px;
  text-align: center;
}

.transport-detail {
  margin: auto;
  transform: scale(1.75);
  overflow: visible;
}

.barplot-chart-container {
  width: 100%;
}
</style>
